import api from './axiosInstance';

// ── Read ───────────────────────────────────────────────────────────────────
export const listExpertViews = (params = {}) =>
  api.get('/expert-view', { params });

export const getExpertView = (id) => api.get(`/expert-view/${id}`);

export const getExpertViewMeta = () => api.get('/expert-view/meta');

// Returns absolute URL to the image (used by <img src=...>)
export const getImageUrl = (imageUrl) => {
  if (!imageUrl) return '';
  if (/^https?:\/\//i.test(imageUrl)) return imageUrl;
  // imageUrl looks like "/uploads/expert-view/<file>"
  // Strip "/api" suffix from baseURL because uploads are served from server root
  const base = (api.defaults.baseURL || '').replace(/\/api\/?$/, '');
  return `${base}${imageUrl}`;
};

// Force-download endpoint (returns binary)
export const downloadExpertViewBlob = (id) =>
  api.get(`/expert-view/${id}/download`, { responseType: 'blob' });

// ── Write ──────────────────────────────────────────────────────────────────
export const createExpertView = (formData, onUploadProgress) =>
  api.post('/expert-view', formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
    onUploadProgress,
  });

export const updateExpertView = (id, body) =>
  api.patch(`/expert-view/${id}`, body);

export const deleteExpertView = (id) => api.delete(`/expert-view/${id}`);
